export const ZONE = {
    /** Square ground plane, centred on the origin. */
    size: 80,
    bounds: { minX: -39, maxX: 39, minZ: -39, maxZ: 39 },
    groundHeight: 0,
    maxClients: 20,
    /** Half-width of the path strip running along the Z axis. */
    pathHalfWidth: 3,
    /** Open area around the cat shrine at the origin. */
    clearingRadius: 8,
    /** Radius kept free around the shrine, spawn points, and the path. */
    sceneryClearance: 4,
    sceneryCounts: { trees: 90, rocks: 40, grass: 220 },
    scenerySeed: 20260728,
};
export const PLAYER_SPAWN_POINTS = [
    { x: 9, z: 7 },
    { x: -9, z: 7 },
    { x: 9, z: -7 },
    { x: -9, z: -7 },
];
export const ENEMY_SPAWN_POINTS = [
    { id: "sprite-north", archetype: "forestSprite", x: 6, z: 26, patrolRadius: 6 },
    { id: "sprite-east", archetype: "forestSprite", x: 24, z: 10, patrolRadius: 6 },
    { id: "sprite-south", archetype: "forestSprite", x: -8, z: -25, patrolRadius: 6 },
    { id: "sprite-west", archetype: "forestSprite", x: -26, z: -6, patrolRadius: 6 },
    { id: "sprite-deep", archetype: "forestSprite", x: 22, z: -22, patrolRadius: 7 },
];
/** Deterministic PRNG so client scenery and server clearance agree. */
function seededRandom(seed) {
    let a = seed >>> 0;
    return () => {
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
function isBlocked(x, z) {
    if (Math.abs(x) <= ZONE.pathHalfWidth + 1)
        return true;
    if (Math.hypot(x, z) <= ZONE.clearingRadius)
        return true;
    const clearance = ZONE.sceneryClearance;
    const nearSpawn = (point) => Math.hypot(x - point.x, z - point.z) <= clearance;
    return PLAYER_SPAWN_POINTS.some(nearSpawn) || ENEMY_SPAWN_POINTS.some(nearSpawn);
}
function scatter(count, random, minScale, maxScale) {
    const items = [];
    const half = ZONE.size / 2 - 2;
    // Rejection sampling: a blocked candidate is dropped, not retried, so the
    // counts in the config are an upper bound rather than an exact quota.
    for (let i = 0; i < count; i += 1) {
        const x = (random() * 2 - 1) * half;
        const z = (random() * 2 - 1) * half;
        const scale = minScale + random() * (maxScale - minScale);
        const rotation = random() * Math.PI * 2;
        if (isBlocked(x, z))
            continue;
        items.push({ x, z, scale, rotation });
    }
    return items;
}
const random = seededRandom(ZONE.scenerySeed);
export const SCENERY = {
    trees: scatter(ZONE.sceneryCounts.trees, random, 0.8, 1.6),
    rocks: scatter(ZONE.sceneryCounts.rocks, random, 0.5, 1.4),
    grass: scatter(ZONE.sceneryCounts.grass, random, 0.6, 1.2),
};
export function isInsideBounds(x, z) {
    return (x >= ZONE.bounds.minX && x <= ZONE.bounds.maxX && z >= ZONE.bounds.minZ && z <= ZONE.bounds.maxZ);
}
export function clampToBounds(x, z) {
    return {
        x: Math.min(Math.max(x, ZONE.bounds.minX), ZONE.bounds.maxX),
        z: Math.min(Math.max(z, ZONE.bounds.minZ), ZONE.bounds.maxZ),
    };
}
//# sourceMappingURL=world.js.map